/* Estilos Cart  Custom*/

function $reindexacionRebuy(){
  $('#rebuy-cart .rebuy-cart__flyout').prepend('<div class="rebuy-new-cart"><div class="container-rebuy-cart-new"></div><div class="container-rebuy-cart-recommendation"></div></div>');
  $( "#rebuy-cart .rebuy-new-cart .container-rebuy-cart-new" ).append($( "div[data-rebuy-cart-anchor=header], div[data-rebuy-cart-scroll-area], div[data-rebuy-cart-anchor=footer]" ));
  $('#rebuy-cart .rebuy-new-cart .container-rebuy-cart-recommendation').append('<div data-rebuy-id="271459"></div>');
  $('#rebuy-cart .rebuy-new-cart .container-rebuy-cart-recommendation').prepend('<div data-rebuy-id="225288"></div>');
  $('#rebuy-cart .rebuy-new-cart [data-rebuy-component=cross-sell-widget]').prepend('<div data-rebuy-id="225291"></div>');

  /*
  $('#rebuy-cart div[data-rebuy-cart-anchor="body"]').prepend(`
    <div class="rebuy-gwp-promo">
      <div class="rebuy-gwp-promo__container">
        <div class="rebuy-gwp-promo__media">
          <img
            class="rebuy-gwp-promo__img"
            src="https://cdn.shopify.com/s/files/1/0047/7075/8756/files/image_8d270142-b6a7-4074-a65d-93bca730e713.png"
            alt="Complimentary 0.25ct Single Lab Diamond Stud"
            loading="lazy"
          />
        </div>

        <div class="rebuy-gwp-promo__content">
          <p class="rebuy-gwp-promo__title">Complimentary 0.25ct Stud for Your Second Piercing</p>
          <p class="rebuy-gwp-promo__text">
            Order any lab diamond studs and receive a complimentary 0.25ct single lab diamond stud — perfect for your second piercing.
          </p>

          <a class="rebuy-gwp-promo__btn" href="/collections/lab-diamond-studs-complimentary-gift">
            Shop Lab Diamond Studs
          </a>
        </div>
      </div>
    </div>
  `);*/

  $('div[data-rebuy-component=cross-sell-widget]').before(
    '<div id="stars-rebuy-show">' + 
      '<div class="stars">' + 
        '<svg version="1.1" id="stars-reviews-rebuy-cart" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 67 11.2" style="enable-background:new 0 0 67 11.2;" xml:space="preserve">' +
          '<g>' +
            '<polygon points="7.4,4.1 5.9,0 4.4,4.1 0,4.3 3.4,7 2.2,11.2 5.9,8.8 9.5,11.2 8.3,7 11.8,4.3"/>' +
          	'<polygon points="21.2,4.1 19.7,0 18.2,4.1 13.8,4.3 17.2,7 16,11.2 19.7,8.8 23.3,11.2 22.2,7 25.6,4.3"/>' +
          	'<polygon points="29.8,11.2 33.5,8.8 37.2,11.2 36,7 39.4,4.3 35,4.1 33.5,0 32,4.1 27.6,4.3 31,7"/>' +
          	'<polygon points="48.8,4.1 47.3,0 45.8,4.1 41.4,4.3 44.8,7 43.7,11.2 47.3,8.8 51,11.2 49.8,7 53.2,4.3"/>' +
          	'<polygon points="67,4.3 62.6,4.1 61.1,0 59.6,4.1 55.2,4.3 58.7,7 57.5,11.2 61.1,8.8 64.8,11.2 63.6,7"/>' +
          '</g>' +
        '</svg>' +
      '</div>' + 
      '<div class="message">' + 
        '<p><em>Thousands of Satisfied Customers</em></p>' + 
      '</div>' + 
    '</div>'
  );

  $('#rebuy-cart [data-rebuy-cart-anchor=footer]').prepend(`
    <div class="method-payment">
      <p>We Accept</p>
      <div class="icons">
        <svg id="amex" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#amex .st0-amex{fill:#fff;fill-rule:evenodd;}#amex .st1-amex{fill:#3572b9;stroke:#d9d9d8;stroke-width:2.6px;}</style></defs><rect class="st1-amex" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st0-amex" d="M33.2,45l-17.3,38.3h20.7l2.6-6.1h5.9l2.6,6.1h22.8v-4.7l2,4.7h11.8l2-4.8v4.8h47.5l5.8-6,5.4,6h24.4s-17.4-19.1-17.4-19.1l17.4-19.3h-24l-5.6,5.8-5.2-5.8h-51.7l-4.4,9.9-4.5-9.9h-20.7v4.5l-2.3-4.5h-17.7ZM104.1,50.4h27.3l8.3,9,8.6-9h8.3l-12.7,13.8,12.7,13.7h-8.7l-8.3-9.1-8.7,9.1h-26.8v-27.5ZM110.9,61.1v-5h0s17,0,17,0l7.4,8-7.8,8.1h-16.7v-5.5h14.9v-5.6h-14.9ZM37.2,50.4h10.1l11.5,26v-26h11.1l8.9,18.6,8.2-18.6h11v27.5h-6.7v-21.6c0,0-9.8,21.6-9.8,21.6h-6l-9.8-21.6v21.6h-13.8l-2.6-6.2h-14.1l-2.6,6.2h-7.4l12.2-27.5ZM37.5,66.1l4.7-11,4.6,11h-9.3Z"/></svg>
        <svg id="apple-pay" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#apple-pay .st0-apple-pay{fill:#010101;fill-rule:evenodd;}#apple-pay .st1-apple-pay{fill:#fff;stroke:#d9d9d8;stroke-width:2.6px;}</style></defs><rect class="st1-apple-pay" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st0-apple-pay" d="M44.2,47.3c2.5.2,5-1.3,6.5-3.1,1.5-1.9,2.5-4.5,2.3-7.1-2.2.1-4.9,1.5-6.5,3.4-1.4,1.7-2.6,4.3-2.3,6.8ZM73.8,81.1v-40.9h15.2c7.8,0,13.3,5.5,13.3,13.4s-5.6,13.5-13.5,13.5h-8.7v14h-6.3ZM52.9,47.8c-2.2-.1-4.2.7-5.8,1.3-1,.4-1.9.8-2.6.8s-1.7-.4-2.7-.8c-1.3-.5-2.9-1.2-4.5-1.1-3.7,0-7.2,2.2-9,5.6-3.9,6.8-1,16.8,2.7,22.3,1.8,2.7,4,5.7,6.9,5.6,1.3,0,2.2-.4,3.1-.9,1.1-.5,2.2-1,4-1s2.8.5,3.8.9c1,.4,1.9.9,3.4.8,3,0,4.9-2.7,6.7-5.5,2-2.9,2.9-5.8,3-6.2,0,0,0,0,0,0,0,0,0,0,0,0h0c-.7-.3-5.7-2.7-5.8-9,0-5.3,4-8,4.7-8.4h0s0,0,0,0c-2.6-3.9-6.6-4.3-8-4.4ZM113.7,81.4c3.9,0,7.6-2,9.2-5.2h.1v4.9h5.8v-20.4c0-5.9-4.7-9.7-11.8-9.7s-11.6,3.9-11.8,9.2h5.6c.5-2.5,2.8-4.2,5.9-4.2s6,1.8,6,5.1v2.3l-7.8.5c-7.3.4-11.2,3.5-11.2,8.7s4.1,8.8,9.9,8.8ZM115.3,76.5c-3.3,0-5.5-1.6-5.5-4.1s2-4.1,6-4.3l7-.4v2.3c0,3.8-3.2,6.6-7.5,6.6ZM148.1,82.6c-2.5,7.2-5.4,9.5-11.5,9.5s-2,0-2.4-.2v-4.9c.4,0,1.3.1,1.8.1,2.8,0,4.3-1.2,5.3-4.2l.6-1.8-10.6-29.8h6.6l7.4,24.2h.1l7.4-24.2h6.4l-11,31.3ZM80,45.5h7.2c5.4,0,8.5,2.9,8.5,8.1s-3.1,8.1-8.6,8.1h-7.2v-16.2Z"/></svg>
        <svg id="dinners-club" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#dinners-club .st0-dinners-club{fill:#0779be;}#dinners-club .st1-dinners-club,#dinners-club .st2-dinners-club{fill:#fff;}#dinners-club .st2-dinners-club{stroke:#d9d9d8;stroke-width:2.6px;}</style></defs><rect class="st2-dinners-club" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st0-dinners-club" d="M100.8,103.2c20.6.1,39.4-17,39.4-37.7s-18.8-38.4-39.4-38.4h-17.8c-20.9,0-38.1,15.7-38.1,38.4s17.2,37.8,38.1,37.7h17.8Z"/><path class="st1-dinners-club" d="M83.1,30.2c-19.1,0-34.5,15.6-34.5,34.9,0,19.3,15.5,34.9,34.5,34.9,19.1,0,34.5-15.6,34.5-34.9s-15.5-34.9-34.5-34.9ZM61.2,65c0-4.5,1.3-8.8,3.8-12.5,2.5-3.7,6.1-6.5,10.2-8.1v41.2c-4.2-1.6-7.7-4.5-10.2-8.1-2.5-3.7-3.8-8-3.8-12.5h0ZM91,85.7v-41.2c4.2,1.6,7.7,4.5,10.2,8.1,2.5,3.7,3.8,8,3.8,12.5s-1.3,8.8-3.8,12.5c-2.5,3.7-6.1,6.5-10.2,8.1h0Z"/><path class="st0-dinners-club" d="M100.8,103.2c20.6.1,39.4-17,39.4-37.7s-18.8-38.4-39.4-38.4h-17.8c-20.9,0-38.1,15.7-38.1,38.4s17.2,37.8,38.1,37.7h17.8Z"/><path class="st1-dinners-club" d="M83.1,30.2c-19.1,0-34.5,15.6-34.5,34.9,0,19.3,15.5,34.9,34.5,34.9,19.1,0,34.5-15.6,34.5-34.9s-15.5-34.9-34.5-34.9ZM61.2,65c0-4.5,1.3-8.8,3.8-12.5,2.5-3.7,6.1-6.5,10.2-8.1v41.2c-4.2-1.6-7.7-4.5-10.2-8.1-2.5-3.7-3.8-8-3.8-12.5h0ZM91,85.7v-41.2c4.2,1.6,7.7,4.5,10.2,8.1,2.5,3.7,3.8,8,3.8,12.5s-1.3,8.8-3.8,12.5c-2.5,3.7-6.1,6.5-10.2,8.1h0Z"/></svg> 
        <svg id="discover" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#discover .st0-discover{fill:#010101;}#discover .st1-discover,#discover .st2-discover{fill:#f26228;}#discover .st3-discover{fill:#fff;stroke:#d9d9d8;stroke-width:2.6px;}#discover .st2-discover{fill-rule:evenodd;}</style></defs><rect class="st3-discover" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st1-discover" d="M78,124.4l104.5-30.4v17.2c0,7.3-5.9,13.2-13.2,13.2h-91.3Z"/><path class="st0-discover" d="M65.8,63.7c0-7.4,5.8-13.4,13.2-12.8,2,0,4.3.3,6,1.4v5.7c-1.4-1.7-3.7-2.8-6-2.8-4.6.3-8.3,4.3-8,8.8v.6c0,4.5,3.7,8,8.3,8s4.3-1.1,5.8-2.8v5.7c-2,.9-4,1.4-6.3,1.4-7.2,0-12.9-6-12.9-13.1ZM124.1,67.9l6.9-17.1h5.2l-10.6,25.9h-2.6l-10.6-25.9h5.2l6.6,17.1ZM56,50.3c2.6,0,5.2,1.1,7.2,2.8l-2.6,3.4c-1.2-1.1-2.6-2-4-2-1.7-.3-3.2,1.1-3.5,2.8,0,1.4.9,2,3.7,3.1,5.8,2.3,7.2,4,7.5,7.4v.9c-.3,4.5-4,8-8.6,7.7-3.4,0-6.9-1.7-8.6-4.8l3.2-3.1c.9,2,2.9,3.4,5.2,3.4h.3c1.7,0,3.5-1.7,3.5-3.7s-.6-2-1.4-2.6c-1.1-.6-2.3-1.1-3.4-1.4-4.6-1.4-6-3.4-6-6.8v-.3c.3-4,3.7-7.1,7.8-6.8ZM26.1,50.9c6.9.3,12.4,6,12.1,12.8,0,3.7-1.7,7.1-4.6,9.7-2.6,2-5.8,3.1-8.9,2.8h-7.2v-25.3h8.6ZM45.1,76.2h-4.9v-25.3h4.9v25.3ZM152.3,55.1h-8.9v5.7h8.6v4.3h-8.6v6.8h8.9v4.3h-13.8v-25.3h13.8v4.3ZM162.6,50.9c5.8,0,8.9,2.6,8.9,7.4.3,3.7-2.3,6.8-5.8,7.4l7.8,10.5h-6l-6.6-10.2h-.6v10.2h-4.9v-25.3h7.2ZM30.4,57.1c-1.7-1.4-4.3-2.3-6.6-2h-1.4v16.8h1.4c2.3.3,4.9-.6,6.6-2,1.7-1.7,2.6-4,2.6-6.5s-.9-4.5-2.6-6.3ZM160.3,62.5h1.4c3.2,0,4.6-1.4,4.6-4s-1.4-3.7-4.6-3.7h-1.4v7.7Z"/><path class="st2-discover" d="M99.7,50.3c-7.2,0-13.2,5.7-13.2,13.1s5.8,13.1,13.2,13.4c7.5.3,13.2-5.7,13.5-13.1-.3-7.4-6-13.4-13.5-13.4h0Z"/></svg>
        <svg id="google-pay" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#google-pay .st0-google-pay{fill:#557ebf;}#google-pay .st1-google-pay{fill:#3d4144;}#google-pay .st2-google-pay{fill:#ea4535;}#google-pay .st3-google-pay{fill:#f9bc15;}#google-pay .st4-google-pay{fill:#fff;stroke:#d9d9d8;stroke-width:2.6px;}#google-pay .st5-google-pay{fill:#36a852;}</style></defs><rect class="st4-google-pay" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st1-google-pay" d="M145.5,75.8h0l7.7-19.4h5.4l-16.7,38.9h-5.2l6.2-13.6-10.9-25.3h5.4l7.9,19.4ZM119.4,55.5c3.7,0,6.6,1,8.8,3,2.1,2,3.2,4.8,3.2,8.2v16.6h-4.8v-3.7h-.2c-2.1,3.1-4.8,4.6-8.2,4.6s-5.4-.9-7.4-2.6c-1.9-1.6-3-4.1-2.9-6.6,0-2.8,1-5,3.1-6.7,2.1-1.7,4.9-2.5,8.3-2.5s5.4.6,7.3,1.6v-1.2c0-1.7-.7-3.4-2-4.5-1.3-1.2-3-1.9-4.8-1.9-2.8,0-5,1.2-6.6,3.6l-4.4-2.8c2.4-3.5,5.9-5.3,10.7-5.3ZM95.7,43.9c3.2,0,6.3,1.2,8.6,3.4,4.5,4.3,4.8,11.5.6,16.1l-.6.6c-2.3,2.2-5.2,3.4-8.6,3.4h-8.3v16h-5v-39.5h13.2ZM120,69.9c-2,0-3.7.5-5.1,1.5-1.3,1-2,2.2-2,3.7s.6,2.5,1.6,3.3c1.1.9,2.5,1.4,3.9,1.3,2.1,0,4.1-.8,5.6-2.4,1.7-1.6,2.5-3.4,2.5-5.6-1.6-1.3-3.7-1.9-6.5-1.9ZM87.5,62.6h8.4c1.9,0,3.7-.7,4.9-2,2.6-2.7,2.5-7.1-.2-9.8-1.3-1.3-3-2-4.8-2h-8.4v13.8Z"/><path class="st0-google-pay" d="M70.2,63.9c0-1.5-.1-3.1-.4-4.6h-21.1v8.7h12.1c-.5,2.8-2.1,5.3-4.5,6.9v5.7h7.2c4.2-3.9,6.6-9.8,6.6-16.7Z"/><path class="st5-google-pay" d="M48.8,86.1c6,0,11.1-2,14.8-5.5l-7.2-5.7c-2,1.4-4.6,2.2-7.6,2.2-5.8,0-10.8-4-12.5-9.3h-7.4v5.9c3.8,7.6,11.5,12.5,19.9,12.5Z"/><path class="st3-google-pay" d="M36.3,67.8c-.9-2.8-.9-5.9,0-8.7v-5.8h-7.4c-3.2,6.4-3.2,13.9,0,20.3l7.4-5.8Z"/><path class="st2-google-pay" d="M48.8,49.7c3.2,0,6.3,1.2,8.6,3.4l6.4-6.5c-4.1-3.8-9.4-5.9-14.9-5.9-8.4,0-16.2,4.8-19.9,12.5l7.4,5.9c1.8-5.4,6.7-9.4,12.5-9.4Z"/></svg>
        <svg id="jcb" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#jcb .st0-jcb{fill:#41a648;}#jcb .st1-jcb{fill:#0f68b0;}#jcb .st2-jcb{fill:#fff;stroke:#d9d9d8;stroke-width:2.6px;}#jcb .st3-jcb{fill:#be2335;}</style></defs><rect class="st2-jcb" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><g id="jcb-color-large"><g><path class="st0-jcb" d="M127.3,74.5h11.1c2-.4,3.5-2.2,3.5-4.3,0-2-1.5-3.8-3.5-4.3-.4,0-.8,0-1.2,0h-9.9v8.6Z"/><path class="st0-jcb" d="M136.1,12.1c-9.5,0-17.1,7.7-17.1,17.1v17.8h24.2c.6,0,1.1,0,1.7,0,5.4.3,9.5,3.1,9.5,8-.1,4.3-3.6,7.7-7.8,7.8h0c5.6.4,9.8,3.5,9.8,8.3s-4.7,8.6-10.9,8.6h-26.6v35.2h25.2c9.5,0,17.1-7.7,17.1-17.1V12.1h-25.1Z"/><path class="st0-jcb" d="M140.7,56.3c.2-2.1-1.4-4-3.5-4.3h-9.9v8.3h9c.3,0,.6,0,.9,0,2-.3,3.5-2,3.5-4h0Z"/><path class="st1-jcb" d="M41.2,12.1c-9.5,0-17.1,7.7-17.1,17.1v42.3c4.6,2.4,9.6,3.7,14.8,3.9,2.4.3,4.8-.5,6.6-2.2,1.8-1.7,2.7-4,2.6-6.4v-19.9h14.6v19.9c0,7.7-4.8,14-21.1,14-5.9,0-11.8-.7-17.5-2.1v36.3h25.2c9.5,0,17.1-7.7,17.1-17.1V12.1h-25.2Z"/><path class="st3-jcb" d="M88.7,12.1c-9.5,0-17.1,7.7-17.1,17.1v22.4c4.3-3.7,11.9-6,24-5.4,4.5.3,9,1,13.5,2.1v7.2c-4-2.1-8.4-3.4-12.9-3.8-9.2-.6-14.8,3.9-14.8,11.8s5.6,12.5,14.8,11.8c4.5-.4,8.9-1.7,12.9-3.8v7.2c-4.4,1.1-8.9,1.8-13.5,2.1-12.1.6-19.7-1.8-24-5.4v39.6h25.3c9.5,0,17.1-7.7,17.1-17.1V12.1h-25.3Z"/></g></g></svg>        
        <svg id="mastercard" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#mastercard .st0-mastercard{fill:#f9a11b;}#mastercard .st1-mastercard{fill:#f16022;}#mastercard .st2-mastercard{fill:#fff;stroke:#d9d9d8;stroke-width:2.6px;}#mastercard .st3-mastercard{fill:#ec1d24;}</style></defs><rect class="st2-mastercard" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st3-mastercard" d="M117.3,26.5c19.9,0,36.1,16.4,36.1,36.5s-16.2,36.5-36.1,36.5-17.1-3.3-23.4-8.7c-6.3,5.4-14.5,8.7-23.4,8.7-19.9,0-36.1-16.4-36.1-36.5s16.2-36.5,36.1-36.5,17.1,3.3,23.4,8.7c6.3-5.4,14.5-8.7,23.4-8.7Z"/><path class="st0-mastercard" d="M117.3,26.5c19.9,0,36.1,16.4,36.1,36.5s-16.2,36.5-36.1,36.5-17.1-3.3-23.4-8.7c7.8-6.7,12.7-16.7,12.7-27.8s-4.9-21.1-12.7-27.8c6.3-5.4,14.5-8.7,23.4-8.7Z"/><path class="st1-mastercard" d="M93.9,35.2c7.8,6.7,12.7,16.7,12.7,27.8s-4.9,21.1-12.7,27.8c-7.8-6.7-12.7-16.7-12.7-27.8s4.9-21.1,12.7-27.8Z"/></svg>
        <svg id="paypal" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#paypal .st0-paypal,#paypal .st1-paypal{fill:#253d80;}#paypal .st0-paypal,#paypal .st2-paypal{fill-rule:evenodd;}#paypal .st3-paypal,#paypal .st2-paypal{fill:#189bd7;}#paypal .st4-paypal{fill:#fff;stroke:#d9d9d8;stroke-width:2.6px;}#paypal .st5-paypal{fill:#242e65;}</style></defs><rect class="st4-paypal" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st0-paypal" d="M52.4,80.6h-8.2c-.6,0-1.1.4-1.1,1l-3.3,21.1c0,.4.2.8.7.8h3.9c.6,0,1-.4,1.1-1l.9-5.7c0-.6.6-1,1.1-1h2.6c5.4,0,8.6-2.6,9.4-7.8.4-2.3,0-4.1-1-5.3-1.2-1.4-3.2-2.1-6-2.1ZM53.3,88.4c-.4,3-2.7,3-4.9,3h-1.2l.9-5.5c0-.3.3-.6.7-.6h.6c1.5,0,2.9,0,3.6.8.4.5.6,1.3.4,2.3ZM77,88.3h-3.9c-.3,0-.6.2-.7.6l-.2,1.1-.3-.4c-.9-1.2-2.8-1.7-4.7-1.7-4.4,0-8.1,3.3-8.8,7.9-.4,2.3.2,4.5,1.5,6.1,1.2,1.4,2.9,2,5,2,3.5,0,5.5-2.3,5.5-2.3l-.2,1.1c0,.4.3.8.7.8h3.6c.6,0,1-.4,1.1-1l2.1-13.5c0-.4-.2-.8-.7-.8ZM71.5,95.9c-.4,2.3-2.2,3.8-4.4,3.8s-2.1-.4-2.6-1.1c-.6-.7-.8-1.7-.6-2.8.3-2.2,2.2-3.8,4.4-3.8s2,.4,2.6,1.1c.6.7.8,1.7.7,2.8ZM94,88.3h4c.6,0,.9.6.6,1.1l-13.2,19c-.2.3-.6.5-.9.5h-4c-.6,0-.9-.6-.6-1.1l4.1-5.8-4.4-12.8c-.2-.4.2-.9.7-.9h3.9c.5,0,1,.3,1.1.8l2.3,7.7,5.5-8c.2-.3.6-.5,1-.5Z"/><path class="st2-paypal" d="M137,102.7l3.4-21.5c0-.3.3-.6.7-.6h3.8c.4,0,.7.4.7.8l-3.3,21.1c0,.6-.6,1-1.1,1h-3.4c-.4,0-.7-.4-.7-.8ZM111.1,80.6h-8.2c-.6,0-1,.4-1.1,1l-3.3,21.1c0,.4.3.8.7.8h4.2c.4,0,.7-.3.8-.7l1-6c0-.6.6-1,1.1-1h2.6c5.4,0,8.5-2.6,9.4-7.8.4-2.3,0-4.1-1.1-5.3-1.2-1.4-3.2-2.1-6-2.1ZM112.1,88.4c-.5,3-2.7,3-4.9,3h-1.2l.9-5.5c0-.3.3-.6.7-.6h.6c1.5,0,2.9,0,3.6.8.4.5.6,1.3.4,2.3ZM135.7,88.3h-3.9c-.3,0-.6.2-.7.6l-.2,1.1-.3-.4c-.8-1.2-2.8-1.7-4.7-1.7-4.4,0-8.1,3.3-8.8,7.9-.4,2.3.2,4.5,1.5,6.1,1.2,1.4,2.9,2,5,2,3.5,0,5.5-2.3,5.5-2.3l-.2,1.1c0,.4.3.8.7.8h3.6c.6,0,1-.4,1.1-1l2.1-13.5c0-.4-.3-.8-.7-.8ZM130.2,95.9c-.4,2.3-2.2,3.8-4.4,3.8s-2.1-.4-2.7-1.1c-.6-.7-.8-1.7-.6-2.8.4-2.2,2.2-3.8,4.4-3.8s2,.4,2.6,1.1c.6.7.8,1.7.7,2.8Z"/><path class="st1-paypal" d="M82.9,73.1l1-6.4h-2.2c0,0-10.8,0-10.8,0l7.5-47.4c0-.1,0-.3.2-.4.1,0,.3-.1.4-.1h18.1c6,0,10.2,1.3,12.4,3.7,1,1.2,1.7,2.4,2,3.7.3,1.4.3,3.1,0,5.1h0v1.5l1,.6c.8.5,1.5,1,2.1,1.6.9,1,1.4,2.3,1.7,3.8.2,1.5.2,3.4-.2,5.4-.5,2.4-1.2,4.5-2.2,6.2-.9,1.6-2.1,2.9-3.5,3.9-1.3,1-3,1.7-4.8,2.1-1.8.5-3.8.7-5.9.7h-1.4c-1,0-2,.4-2.8,1-.8.7-1.3,1.6-1.4,2.6v.6c-.1,0-1.9,11.3-1.9,11.3v.4c0,.1-.1.2-.2.2,0,0-.1,0-.2,0h-8.7Z"/><path class="st3-paypal" d="M113.4,31.5c0,.3-.1.7-.2,1.1-2.4,12.3-10.6,16.5-21,16.5h-5.3c-1.3,0-2.4.9-2.6,2.2l-2.7,17.3-.8,4.9c-.1.8.5,1.6,1.3,1.6h9.4c1.1,0,2.1-.8,2.3-1.9v-.5c0,0,1.9-11.3,1.9-11.3v-.6c.3-1.1,1.2-1.9,2.4-1.9h1.4c9.2,0,16.3-3.7,18.4-14.5.9-4.5.4-8.2-1.9-10.9-.7-.8-1.6-1.5-2.6-2Z"/><path class="st5-paypal" d="M110.9,30.5c-.4-.1-.8-.2-1.1-.3-.4,0-.8-.2-1.2-.2-1.4-.2-3-.3-4.7-.3h-14.2c-.3,0-.7,0-1,.2-.7.3-1.2.9-1.3,1.7l-3,19.2v.6c.1-1.3,1.2-2.2,2.5-2.2h5.3c10.5,0,18.7-4.2,21-16.5,0-.4.1-.7.2-1.1-.6-.3-1.3-.6-2-.8-.2,0-.4-.1-.5-.2Z"/><path class="st1-paypal" d="M87.4,31.6c.1-.8.6-1.4,1.3-1.7.3-.1.6-.2,1-.2h14.2c1.7,0,3.3.1,4.7.3.4,0,.8.1,1.2.2.4,0,.8.2,1.1.3.2,0,.4.1.5.2.7.2,1.4.5,2,.8.7-4.5,0-7.6-2.5-10.4-2.7-3.1-7.6-4.4-13.8-4.4h-18.2c-1.3,0-2.4.9-2.6,2.2l-7.6,47.9c-.2.9.6,1.8,1.5,1.8h11.2l2.8-17.9,3-19.2Z"/></svg>        
        <svg id="shoppay" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#shoppay .st0-shoppay{fill:#fff;}#shoppay .st1-shoppay{fill:#5956a5;stroke:#d9d9d8;stroke-width:2.6px;}</style></defs><rect class="st1-shoppay" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st0-shoppay" d="M104.3,58.5c0,8.2-5.7,14-13.7,14h-7.5c0,0-.2,0-.2,0,0,0-.2,0-.2.1,0,0,0,.1-.1.2,0,0,0,.2,0,.2v10.7c0,.2,0,.3-.2.4-.1.1-.3.2-.4.2h-5.3c-.1,0-.2,0-.3-.1-.1,0-.2-.2-.2-.3,0,0,0-.2,0-.2v-38.7c0,0,0-.2,0-.2,0,0,0-.1.1-.2,0,0,.1-.1.2-.1,0,0,.2,0,.2,0h14.1c8,0,13.7,5.8,13.7,14h0ZM97.7,58.5c0-4.7-3.2-8.1-7.5-8.1h-7.1c0,0-.2,0-.2,0,0,0-.2,0-.2.1,0,0,0,.1-.1.2,0,0,0,.2,0,.2v14.9c0,.2,0,.3.2.4.1.1.3.2.5.2h7.1c4.3,0,7.5-3.4,7.5-8.1ZM105.8,77.1c0-1.2.2-2.5.8-3.6.6-1.1,1.4-2.1,2.4-2.8,2.1-1.5,5.3-2.3,10-2.5l5-.2v-1.5c0-3-2-4.2-5.2-4.2s-5.2,1.1-5.7,3c0,.1-.1.2-.2.3-.1,0-.2.1-.4.1h-5c0,0-.2,0-.3,0,0,0-.2,0-.2-.2,0,0-.1-.1-.1-.2,0,0,0-.2,0-.3.7-4.4,4.4-7.7,12.1-7.7s11.2,3.8,11.2,11.1v15.5c0,.2,0,.3-.2.5s-.3.2-.5.2h-5c-.2,0-.3,0-.5-.2,0,0,0-.1-.1-.2,0,0,0-.2,0-.2v-1.2c0,0,0-.2,0-.3,0,0-.1-.1-.2-.2s-.2,0-.3,0c0,0-.2,0-.2.1-1.5,1.6-3.9,2.8-7.8,2.8-5.7,0-9.5-3-9.5-8.1h0ZM124,73.7v-1.2l-6.5.3c-3.4.2-5.4,1.6-5.4,4s1.8,3.4,5,3.4,6.9-2.3,6.9-6.5h0ZM135.2,96.2v-4.5c0,0,0-.2,0-.3,0,0,0-.2.2-.2,0,0,.2-.1.2-.1,0,0,.2,0,.3,0,.8.1,1.6.2,2.3.2,1.3,0,2.7-.3,3.8-1.1,1.1-.8,1.9-1.9,2.3-3.2l.3-1c0-.1,0-.3,0-.4l-10.4-26.7c0,0,0-.2,0-.3,0-.1,0-.2.1-.3,0,0,.1-.2.2-.2,0,0,.2,0,.3,0h5c.1,0,.3,0,.4.1,0,0,.2.2.2.3l7.1,18.9c0,.1.1.2.2.3,0,0,.2.1.4.1s.3,0,.4-.1c.1,0,.2-.2.2-.3l6.1-18.8c0-.1.1-.2.2-.3.1,0,.2-.1.4-.1h5.2c.1,0,.2,0,.3,0,0,0,.2.1.2.2,0,0,0,.2.1.3,0,.1,0,.2,0,.3l-11.1,29.7c-2.6,6.9-7,8.7-11.8,8.7-.9,0-1.8,0-2.7-.3-.1,0-.3-.1-.4-.3,0-.1-.1-.3-.1-.4h0ZM42.1,42.3c-6.6,0-13,2.5-17.9,7-.2.2-.3.5-.4.7,0,.3,0,.6.2.8l3,4.1c0,.1.2.2.4.3.2,0,.3.1.5.1.2,0,.3,0,.5,0s.3-.2.4-.3c1.7-1.7,3.8-3.1,6.1-4.1,2.3-.9,4.7-1.4,7.2-1.4,10.3,0,15.7,7.7,15.7,15.4s-5.7,14.2-13.8,14.3c-6.3,0-11-4.2-11-9.7,0-1.4.3-2.8.9-4,.6-1.3,1.5-2.4,2.5-3.2.2-.2.4-.5.4-.8,0-.3,0-.6-.2-.8l-3.2-4c0-.1-.2-.2-.3-.3-.1,0-.3-.1-.4-.1-.2,0-.3,0-.5,0s-.3.1-.4.2c-1.9,1.6-3.5,3.5-4.6,5.8-1.1,2.2-1.6,4.7-1.6,7.2,0,9.5,8,16.9,18.3,16.9h.1c12.2-.2,21.1-9.2,21.1-21.6s-8.1-22.7-23.1-22.7h0Z"/></svg>        
        <svg id="visa" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 185.2 127"><defs><style>#visa .st0-visa{fill:#fff;stroke:#d9d9d8;stroke-width:2.6px;}#visa .st1-visa{fill:#2a3580;fill-rule:evenodd;}</style></defs><rect class="st0-visa" x="1.3" y="1.3" width="182.6" height="124.4" rx="14.6" ry="14.6"/><path class="st1-visa" d="M56.2,86h-11.2l-8.4-32.1c-.4-1.5-1.2-2.8-2.5-3.4-3.1-1.5-6.5-2.8-10.3-3.4v-1.2h18.1c2.5,0,4.4,1.9,4.7,4l4.4,23.2,11.2-27.2h10.9l-16.8,40.1ZM79.3,86h-10.6l8.7-40.1h10.6l-8.7,40.1ZM101.7,57c.3-2.2,2.2-3.4,4.4-3.4,3.4-.3,7.2.3,10.3,1.9l1.9-8.6c-3.1-1.2-6.5-1.9-9.7-1.9-10.3,0-17.8,5.6-17.8,13.3s5.3,8.9,9,10.8c4.1,1.9,5.6,3.1,5.3,4.9,0,2.8-3.1,4-6.2,4s-7.5-.9-10.9-2.5l-1.9,8.6c3.8,1.5,7.8,2.2,11.5,2.2,11.5.3,18.7-5.2,18.7-13.6s-14.7-11.1-14.7-15.7h0ZM153.5,86l-8.4-40.1h-9c-1.9,0-3.7,1.2-4.4,3.1l-15.6,37h10.9l2.2-5.9h13.4l1.2,5.9h9.7ZM137.6,56.7l3.1,15.1h-8.7l5.6-15.1Z"/></svg>
      </div>
    </div>
  
    <div class="message-internation-shipping">
      <p>Free Shipping & Returns Available – Taxes Calculated at Checkout. <a href="/policies/shipping-policy" target="_blank">See Local & International Policies</a>.</p>
    </div>
  `);
  
};


function ajustarAltura() {
  var contenedor = document.querySelector('.container-rebuy-cart-new');
  if (!contenedor) {
    console.warn('ajustarAltura(): contenedor no encontrado todavía');
    return;
  }

  var alturaVisible = window.innerHeight + "px";
  contenedor.style.height = alturaVisible;
  console.log('Altura ajustada:', alturaVisible);
};

window.addEventListener("resize", ajustarAltura);











// ==========================================
// New GWP by Hulk subtotal + Rebuy triggers
// ==========================================
const REBUY_HULK_GWP_CONFIG = {
  debug: false,

  selectors: {
    footer: '#rebuy-cart .rebuy-cart__flyout [data-rebuy-cart-anchor="footer"]',
    subtotal: '#rebuy-cart [data-hulkapps-cart-total]',
    body: '#rebuy-cart div[data-rebuy-cart-anchor="body"]'
  },


  thresholds: {
    anyOrder: 50000,
    over1000: 150000
  },

  gifts: {
    anyOrder: {
      productId: 15484665463101,
      variantId: 67912777597245
    },
    over1000: {
      productId: 10302127243581,
      variantId: 51574414704957
    }
  },



  timing: {
    debounceMs: 150,
    stableSubtotalMs: 320,
    lockReleaseMs: 700,
    overlayHideDelayMs: 250,
    hydrationGraceMs: 1200,
    // Antes de QUITAR un regalo se espera este tiempo y se vuelve a leer
    // el subtotal. Evita quitarlo mientras Hulk aún no suma la personalización.
    removalConfirmMs: 2000
  }
};

let rebuyHulkGwpObserver = null;
let rebuyHulkGwpDebounce = null;
let rebuyHulkGwpStableTimer = null;
let rebuyHulkGwpOverlayTimer = null;
let rebuyHulkGwpLastSubtotal = null;
let rebuyHulkGwpLock = false;
let rebuyHulkGwpBootedAt = 0;
let rebuyHulkGwpRemovalPendingSince = null;
let rebuyHulkGwpRemovalTimer = null;

function rebuyHulkGwpLog() {
  if (!REBUY_HULK_GWP_CONFIG.debug) return;
  console.log.apply(console, ['[Rebuy Hulk GWP]'].concat([].slice.call(arguments)));
}

function parseRebuyMoneyToCents(text) {
  if (!text) return 0;

  let value = String(text).trim().replace(/[^\d,.-]/g, '');
  const hasComma = value.includes(',');
  const hasDot = value.includes('.');

  if (hasComma && hasDot) {
    if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
      value = value.replace(/\./g, '').replace(',', '.');
    } else {
      value = value.replace(/,/g, '');
    }
  } else if (hasComma && !hasDot) {
    value = value.replace(',', '.');
  } else {
    value = value.replace(/,/g, '');
  }

  const amount = parseFloat(value);
  return Number.isNaN(amount) ? 0 : Math.round(amount * 100);
}

function formatUsdFromCents(cents) {
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });
}


function formatGwpAmount(cents) {
  return '$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
}

// ==========================================
// Estado GWP compartido con el PDP
// El PDP (snippet-gwp-progress) escucha 'gwp770:update'
// y lee window.gwp770. Fuente de verdad: subtotal de Hulk.
// ==========================================
function publishGwpState(subtotalCents) {
  const prev = window.gwp770;
  const state = {
    ready: true,
    subtotalCents: subtotalCents,
    thresholds: {
      gift1: REBUY_HULK_GWP_CONFIG.thresholds.anyOrder,
      gift2: REBUY_HULK_GWP_CONFIG.thresholds.over1000
    }
  };

  window.gwp770 = state;

  // Solo avisa si cambió algo
  if (prev && prev.ready && prev.subtotalCents === subtotalCents) return;

  rebuyHulkGwpLog('publish state', state);
  document.dispatchEvent(new CustomEvent('gwp770:update', { detail: state }));
}

function getHulkCartSubtotalCents() {
  const subtotalNode = document.querySelector(REBUY_HULK_GWP_CONFIG.selectors.subtotal);
  if (!subtotalNode) return 0;
  return parseRebuyMoneyToCents(subtotalNode.textContent);
}

function fetchCartJson() {
  return fetch('/cart.js', {
    method: 'GET',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  }).then(function(res) {
    return res.json();
  });
}

const REBUY_GIFT_WRAPPING_PRODUCT_ID = 10306204041533;
const REBUY_GIFT_WRAPPING_VARIANT_ID = 51588565238077;

function isGiftWrappingLine(item) {
  if (!item) return false;

  return (
    String(item.product_id) === String(REBUY_GIFT_WRAPPING_PRODUCT_ID) ||
    String(item.variant_id) === String(REBUY_GIFT_WRAPPING_VARIANT_ID) ||
    String(item.id) === String(REBUY_GIFT_WRAPPING_VARIANT_ID)
  );
}

function isAuxiliaryCartLine(item) {
  return isGiftLine(item) || isGiftWrappingLine(item);
}

function getRealProductItems(cartItems) {
  return (cartItems || []).filter(function(item) {
    return !isAuxiliaryCartLine(item);
  });
}

function isGiftLine(item) {
  if (!item) return false;

  const gift1 = REBUY_HULK_GWP_CONFIG.gifts.anyOrder;
  const gift2 = REBUY_HULK_GWP_CONFIG.gifts.over1000;

  return (
    String(item.product_id) === String(gift1.productId) ||
    String(item.variant_id) === String(gift1.variantId) ||
    String(item.id) === String(gift1.variantId) ||
    String(item.product_id) === String(gift2.productId) ||
    String(item.variant_id) === String(gift2.variantId) ||
    String(item.id) === String(gift2.variantId)
  );
}

function getRealCartItems(cartItems) {
  return getRealProductItems(cartItems);
}

function hasOnlyGiftItems(cartItems) {
  const items = cartItems || [];
  return items.length > 0 && items.every(function(item) {
    return isGiftLine(item);
  });
}

function shouldSkipHydrationSync(subtotalCents, cartItems) {
  const inGraceWindow =
    rebuyHulkGwpBootedAt &&
    (Date.now() - rebuyHulkGwpBootedAt) < REBUY_HULK_GWP_CONFIG.timing.hydrationGraceMs;

  const hasRealItems = getRealCartItems(cartItems).length > 0;

  // Solo skip si estamos justo al boot, subtotal 0 temporal y aún existen items reales.
  return inGraceWindow && subtotalCents === 0 && hasRealItems;
}

function findGiftLines(cartItems, giftConfig) {
  return (cartItems || []).filter(function(item) {
    return (
      String(item.product_id) === String(giftConfig.productId) ||
      String(item.variant_id) === String(giftConfig.variantId) ||
      String(item.id) === String(giftConfig.variantId)
    );
  });
}

function sumGiftQty(lines) {
  return (lines || []).reduce(function(acc, item) {
    return acc + (item.quantity || 0);
  }, 0);
}

function ensureRebuyCartOverlay() {
  const container = document.querySelector('.container-rebuy-cart-new');
  if (!container) return;

  if (container.querySelector('.rebuy-cart-sync-overlay')) return;

  container.insertAdjacentHTML(
    'beforeend',
    `
    <div class="rebuy-cart-sync-overlay" aria-hidden="true">
      <div class="rebuy-cart-sync-overlay__box">
        <div class="rebuy-cart-sync-overlay__spinner"></div>
        <p class="rebuy-cart-sync-overlay__text">Updating your cart...</p>
      </div>
    </div>
    `
  );
}

function showRebuyCartOverlay() {
  ensureRebuyCartOverlay();
  const overlay = document.querySelector('.rebuy-cart-sync-overlay');
  if (!overlay) return;
  overlay.classList.add('is-visible');
}

function hideRebuyCartOverlay() {
  const overlay = document.querySelector('.rebuy-cart-sync-overlay');
  if (!overlay) return;
  overlay.classList.remove('is-visible');
}

function updateCartLines(updates) {
  if (!updates || !Object.keys(updates).length) return Promise.resolve();

  rebuyHulkGwpLock = true;

  return fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ updates: updates })
  })
    .then(function(res) {
      return res.json().catch(function() { return {}; });
    })
    .catch(function() {})
    .finally(function() {
      setTimeout(function() {
        rebuyHulkGwpLock = false;
      }, REBUY_HULK_GWP_CONFIG.timing.lockReleaseMs);
    });
}

function addGiftVariants(items) {
  if (!items || !items.length) return Promise.resolve();

  rebuyHulkGwpLock = true;

  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      items: items
    })
  })
    .then(function(res) {
      return res.json().catch(function() { return {}; });
    })
    .catch(function() {})
    .finally(function() {
      setTimeout(function() {
        rebuyHulkGwpLock = false;
      }, REBUY_HULK_GWP_CONFIG.timing.lockReleaseMs);
    });
}

function normalizeGiftQuantity(lines, expectedQty, updates) {
  if (!lines || !lines.length) return;

  lines.forEach(function(line, index) {
    updates[line.key] = index === 0 ? expectedQty : 0;
  });
}




const RETIRED_GIFTS = [
  { productId: 10302123802941, variantId: 51574322921789 }
];

function removeDisabledGift2(cartItems) {
  const updates = {};

  (cartItems || []).forEach(function(item) {
    const isRetired = RETIRED_GIFTS.some(function(gift) {
      return (
        String(item.product_id) === String(gift.productId) ||
        String(item.variant_id) === String(gift.variantId)
      );
    });
    if (isRetired) updates[item.key] = 0;
  });

  if (!Object.keys(updates).length) return Promise.resolve();

  rebuyHulkGwpLog('Removing retired gifts', updates);

  return fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates: updates })
  })
    .then(function(res) { return res.json().catch(function() { return {}; }); })
    .catch(function() {});
}



function ensureRebuyGwpProgress() {
  const bodyAnchor = document.querySelector(REBUY_HULK_GWP_CONFIG.selectors.body);
  if (!bodyAnchor) return;

  if (bodyAnchor.querySelector('.rebuy-cart-gwp-progress')) return;

  const t1 = formatGwpAmount(REBUY_HULK_GWP_CONFIG.thresholds.anyOrder);  // $500
  const t2 = formatGwpAmount(REBUY_HULK_GWP_CONFIG.thresholds.over1000);  // $1,500

  bodyAnchor.insertAdjacentHTML(
    'afterbegin',
    `
    <div class="rebuy-cart-gwp-progress">
      <div class="rebuy-cart-gwp-progress__inner">
        <div class="rebuy-cart-gwp-progress__title-wrap">
          <h3 class="rebuy-cart-gwp-progress__title">Complimentary gifts with your order</h3>
        </div>

        <div class="rebuy-cart-gwp-progress__row">
          <div class="rebuy-cart-gwp-progress__segment" data-gwp-tooltip-segment>
            <div class="rebuy-cart-gwp-progress__track">
              <div class="rebuy-cart-gwp-progress__fill" data-gwp-fill="gift-1"></div>
            </div>

            <div class="rebuy-cart-gwp-progress__step" data-gwp-step="gift-1">
              <button
                type="button"
                class="rebuy-cart-gwp-progress__icon rebuy-cart-gwp-progress__icon-button"
                data-gwp-icon="gift-1"
                data-gwp-tooltip-toggle
                aria-expanded="false"
                aria-label="View ${t1}+ gift details"
              >
                🔒
              </button>
              <span class="rebuy-cart-gwp-progress__label">${t1}+ Gift</span>
            </div>

            <div class="rebuy-cart-gwp-tooltip" data-gwp-tooltip>
              <div class="rebuy-cart-gwp-tooltip__inner">
                <div class="rebuy-cart-gwp-tooltip__image">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0047/7075/8756/files/pouch-espresso.png?v=1793812598"
                    alt="Espresso Pouch"
                    loading="lazy"
                  >
                </div>
                <div class="rebuy-cart-gwp-tooltip__content">
                  <p class="rebuy-cart-gwp-tooltip__title">Espresso Pouch</p>
                  <p class="rebuy-cart-gwp-tooltip__text">Complimentary with orders of ${t1} or more.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="rebuy-cart-gwp-progress__segment" data-gwp-tooltip-segment>
            <div class="rebuy-cart-gwp-progress__track">
              <div class="rebuy-cart-gwp-progress__fill" data-gwp-fill="gift-2"></div>
            </div>

            <div class="rebuy-cart-gwp-progress__step" data-gwp-step="gift-2">
              <button
                type="button"
                class="rebuy-cart-gwp-progress__icon rebuy-cart-gwp-progress__icon-button"
                data-gwp-icon="gift-2"
                data-gwp-tooltip-toggle
                aria-expanded="false"
                aria-label="View ${t2}+ gift details"
              >
                🔒
              </button>
              <span class="rebuy-cart-gwp-progress__label">${t2}+ Gift</span>
            </div>

            <div class="rebuy-cart-gwp-tooltip" data-gwp-tooltip>
              <div class="rebuy-cart-gwp-tooltip__inner">
                <div class="rebuy-cart-gwp-tooltip__image">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0047/7075/8756/files/ADS_CUADRADOS-18.jpg"
                    alt="The IT Diamond Cleaning Pen"
                    loading="lazy"
                  >
                </div>
                <div class="rebuy-cart-gwp-tooltip__content">
                  <p class="rebuy-cart-gwp-tooltip__title">The "IT" Diamond Cleaning Pen</p>
                  <p class="rebuy-cart-gwp-tooltip__text">Complimentary with orders of ${t2} or more.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p class="rebuy-cart-gwp-progress__message" data-gwp-message>
          Complimentary gifts with orders of ${t1} or more.
        </p>
      </div>
    </div>
    `
  );
}


function initRebuyGwpTooltips() {
  const segments = document.querySelectorAll('#rebuy-cart [data-gwp-tooltip-segment]');
  if (!segments.length) return;

  function closeAllTooltips(exceptSegment) {
    document.querySelectorAll('#rebuy-cart [data-gwp-tooltip-segment].is-tooltip-open').forEach(function(item) {
      if (exceptSegment && item === exceptSegment) return;
      item.classList.remove('is-tooltip-open');

      const btn = item.querySelector('[data-gwp-tooltip-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  segments.forEach(function(segment) {
    if (segment.dataset.tooltipBound === 'true') return;
    segment.dataset.tooltipBound = 'true';

    const toggle = segment.querySelector('[data-gwp-tooltip-toggle]');
    if (!toggle) return;

    segment.addEventListener('click', function(e) {
      const isMobile = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (!isMobile) return;

      const clickedTooltip = e.target.closest('[data-gwp-tooltip]');
      if (clickedTooltip) return;

      const isOpen = segment.classList.contains('is-tooltip-open');

      closeAllTooltips(segment);

      if (!isOpen) {
        segment.classList.add('is-tooltip-open');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        segment.classList.remove('is-tooltip-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  if (!document.body.dataset.rebuyGwpTooltipOutsideBound) {
    document.body.dataset.rebuyGwpTooltipOutsideBound = 'true';

    document.addEventListener('click', function(e) {
      const clickedInside = e.target.closest('#rebuy-cart [data-gwp-tooltip-segment]');
      if (clickedInside) return;

      closeAllTooltips();
    });
  }
}



function setGwpProgressState(subtotalCents) {
  ensureRebuyGwpProgress();

  // Scope al carrito: evita chocar con la barra del PDP (paso 8)
  const root = document.querySelector('#rebuy-cart .rebuy-cart-gwp-progress');
  if (!root) return;

  const fill1 = root.querySelector('[data-gwp-fill="gift-1"]');
  const fill2 = root.querySelector('[data-gwp-fill="gift-2"]');
  const icon1 = root.querySelector('[data-gwp-icon="gift-1"]');
  const icon2 = root.querySelector('[data-gwp-icon="gift-2"]');
  const step1 = root.querySelector('[data-gwp-step="gift-1"]');
  const step2 = root.querySelector('[data-gwp-step="gift-2"]');
  const message = root.querySelector('[data-gwp-message]');
  const titleWrap = root.querySelector('.rebuy-cart-gwp-progress__title-wrap');

  if (!fill1 || !fill2 || !icon1 || !icon2 || !step1 || !step2 || !message || !titleWrap) return;

  const threshold1 = REBUY_HULK_GWP_CONFIG.thresholds.anyOrder;   // $500
  const threshold2 = REBUY_HULK_GWP_CONFIG.thresholds.over1000;   // $1,500
  const subtotal = Math.max(subtotalCents || 0, 0);

  function setTitle(text) {
    titleWrap.innerHTML = '<h3 class="rebuy-cart-gwp-progress__title">' + text + '</h3>';
  }

  function pct(value) {
    return Math.min(Math.max(value, 0), 100) + '%';
  }

  // Estado 1: menos de $500
  if (subtotal < threshold1) {
    fill1.style.width = pct((subtotal / threshold1) * 100);
    fill2.style.width = '0%';
    icon1.textContent = '🔒';
    icon2.textContent = '🔒';
    step1.classList.remove('is-active');
    step2.classList.remove('is-active');
    setTitle('Complimentary gifts with your order');
    message.innerHTML =
      "You're <strong>" + formatUsdFromCents(threshold1 - subtotal) +
      '</strong> away from a complimentary Espresso Pouch.';
    return;
  }

  // Estado 2: de $500 a $1,499.99 (el segundo tramo mide solo de $500 a $1,500)
  if (subtotal < threshold2) {
    fill1.style.width = '100%';
    fill2.style.width = pct(((subtotal - threshold1) / (threshold2 - threshold1)) * 100);
    icon1.textContent = '✓';
    icon2.textContent = '🔒';
    step1.classList.add('is-active');
    step2.classList.remove('is-active');
    setTitle('Your Espresso Pouch is included');
    message.innerHTML =
      'Add <strong>' + formatUsdFromCents(threshold2 - subtotal) +
      '</strong> more to also receive the "IT" Diamond Cleaning Pen.';
    return;
  }

  // Estado 3: $1,500 o más
  fill1.style.width = '100%';
  fill2.style.width = '100%';
  icon1.textContent = '✓';
  icon2.textContent = '✓';
  step1.classList.add('is-active');
  step2.classList.add('is-active');
  setTitle('Both complimentary gifts are included');
  message.textContent = 'Your Espresso Pouch and "IT" Diamond Cleaning Pen are on us.';
}


function waitForStableHulkSubtotal(callback) {
  clearTimeout(rebuyHulkGwpStableTimer);

  rebuyHulkGwpStableTimer = setTimeout(function() {
    const subtotalCents = getHulkCartSubtotalCents();
    callback(subtotalCents);
  }, REBUY_HULK_GWP_CONFIG.timing.stableSubtotalMs);
}








async function syncRebuyGiftsFromSubtotal(subtotalCents, cartItems) {
  if (rebuyHulkGwpLock) return { skipped: true };

  if (shouldSkipHydrationSync(subtotalCents, cartItems)) {
    rebuyHulkGwpLog('Skipping sync during hydration grace window');
    return { skipped: true };
  }

  const realItems = getRealProductItems(cartItems);
  const hasRealItems = realItems.length > 0;

  const gift1Config = REBUY_HULK_GWP_CONFIG.gifts.anyOrder;
  const gift2Config = REBUY_HULK_GWP_CONFIG.gifts.over1000;

  const gift1Lines = findGiftLines(cartItems, gift1Config);
  const gift2Lines = findGiftLines(cartItems, gift2Config);

  const gift1Qty = sumGiftQty(gift1Lines);
  const gift2Qty = sumGiftQty(gift2Lines);

  const shouldHaveGift1 =
    hasRealItems &&
    subtotalCents >= REBUY_HULK_GWP_CONFIG.thresholds.anyOrder;

  const shouldHaveGift2 =
    hasRealItems &&
    subtotalCents >= REBUY_HULK_GWP_CONFIG.thresholds.over1000;

  const removals = {};   // regalos que sobran (se confirman antes de quitar)
  const updates = {};    // normalización de cantidades (inmediato)
  const additions = [];

  rebuyHulkGwpLog('sync', {
    subtotalCents: subtotalCents,
    shouldHaveGift1: shouldHaveGift1,
    shouldHaveGift2: shouldHaveGift2,
    gift1Qty: gift1Qty,
    gift2Qty: gift2Qty,
    onlyGiftsInCart: hasOnlyGiftItems(cartItems),
    realItemsCount: getRealCartItems(cartItems).length
  });

  // Gift 1
  if (!shouldHaveGift1) {
    gift1Lines.forEach(function(line) {
      removals[line.key] = 0;
    });
  } else {
    if (!gift1Lines.length) {
      additions.push({
        id: gift1Config.variantId,
        quantity: 1
      });
    } else if (gift1Qty !== 1 || gift1Lines.length > 1) {
      normalizeGiftQuantity(gift1Lines, 1, updates);
    }
  }

  // Gift 2
  if (!shouldHaveGift2) {
    gift2Lines.forEach(function(line) {
      removals[line.key] = 0;
    });
  } else {
    if (!gift2Lines.length) {
      additions.push({
        id: gift2Config.variantId,
        quantity: 1
      });
    } else if (gift2Qty !== 1 || gift2Lines.length > 1) {
      normalizeGiftQuantity(gift2Lines, 1, updates);
    }
  }

  // Quitar regalos: con productos reales en el carrito se confirma primero,
  // porque Hulk puede tardar en sumar la personalización al cargar la página.
  // Si el carrito ya no tiene productos reales, se quitan de inmediato.
  const hasRemovals = Object.keys(removals).length > 0;
  let removalPending = false;

  if (!hasRemovals) {
    // Ya no hay nada que quitar (p. ej. Hulk terminó de sumar): cancela la espera
    rebuyHulkGwpRemovalPendingSince = null;
    clearTimeout(rebuyHulkGwpRemovalTimer);
  } else if (hasRealItems) {
    const confirmMs = REBUY_HULK_GWP_CONFIG.timing.removalConfirmMs;

    if (rebuyHulkGwpRemovalPendingSince === null) {
      rebuyHulkGwpRemovalPendingSince = Date.now();
      rebuyHulkGwpLog('Removal pending, re-checking in ' + confirmMs + 'ms', removals);
      clearTimeout(rebuyHulkGwpRemovalTimer);
      rebuyHulkGwpRemovalTimer = setTimeout(function() {
        refreshRebuyHulkGwp(true);
      }, confirmMs);
      removalPending = true;
    } else if (Date.now() - rebuyHulkGwpRemovalPendingSince < confirmMs) {
      removalPending = true;
    } else {
      rebuyHulkGwpLog('Removal confirmed', removals);
      rebuyHulkGwpRemovalPendingSince = null;
      Object.assign(updates, removals);
    }
  } else {
    rebuyHulkGwpRemovalPendingSince = null;
    clearTimeout(rebuyHulkGwpRemovalTimer);
    Object.assign(updates, removals);
  }

  // Primero elimina / normaliza
  if (Object.keys(updates).length) {
    await updateCartLines(updates);
    return { removalPending: removalPending };
  }

  // Luego agrega faltantes
  if (additions.length) {
    await addGiftVariants(additions);
    return { removalPending: removalPending };
  }

  return { removalPending: removalPending };
}





function refreshRebuyHulkGwp(forceSync) {
  clearTimeout(rebuyHulkGwpDebounce);

  rebuyHulkGwpDebounce = setTimeout(function() {
    waitForStableHulkSubtotal(function(subtotalCents) {
      const subtotalChanged = subtotalCents !== rebuyHulkGwpLastSubtotal;

      rebuyHulkGwpLastSubtotal = subtotalCents;
      setGwpProgressState(subtotalCents);

      if (!subtotalChanged && !forceSync && rebuyHulkGwpLock) {
        return;
      }

      showRebuyCartOverlay();

      fetchCartJson()
        .then(function(cart) {
          const items = cart && cart.items ? cart.items : [];

          return removeDisabledGift2(items).then(function() {
            return fetchCartJson();
          }).then(function(updatedCart) {
            const updatedItems = updatedCart && updatedCart.items ? updatedCart.items : [];
            return syncRebuyGiftsFromSubtotal(subtotalCents, updatedItems).then(function(result) {
              // Comparte el subtotal con el PDP, salvo que:
              // - Hulk aún marque $0 con productos reales (no ha cargado), o
              // - haya un regalo esperando confirmación para quitarse
              //   (el subtotal puede ser transitorio, sin la personalización).
              const hulkNotReady = subtotalCents === 0 && getRealProductItems(updatedItems).length > 0;
              const removalPending = !!(result && result.removalPending);
              if (!hulkNotReady && !removalPending) publishGwpState(subtotalCents);
            });
          });
        })
        .catch(function() {})
        .finally(function() {
          clearTimeout(rebuyHulkGwpOverlayTimer);
          rebuyHulkGwpOverlayTimer = setTimeout(function() {
            hideRebuyCartOverlay();
          }, REBUY_HULK_GWP_CONFIG.timing.overlayHideDelayMs);
        });
    });
  }, REBUY_HULK_GWP_CONFIG.timing.debounceMs);
}

function connectRebuyHulkGwpObserver() {
  const footer = document.querySelector(REBUY_HULK_GWP_CONFIG.selectors.footer);
  if (!footer) return;

  if (rebuyHulkGwpObserver) {
    rebuyHulkGwpObserver.disconnect();
  }

  rebuyHulkGwpObserver = new MutationObserver(function() {
    refreshRebuyHulkGwp(true);
  });

  rebuyHulkGwpObserver.observe(footer, {
    childList: true,
    subtree: true,
    characterData: true
  });

  refreshRebuyHulkGwp(true);
}

function bootRebuyHulkGwp() {
  rebuyHulkGwpBootedAt = Date.now();
  ensureRebuyGwpProgress();
  ensureRebuyCartOverlay();
  initRebuyGwpTooltips();
  connectRebuyHulkGwpObserver();
  refreshRebuyHulkGwp(true);
}













// ==========================================
// Generic GWP by Tag (robusto + reusable)
// ==========================================

const handleSecondPiercingGWP = createGwpByTag({
  tag: "gwp_second_piercing_025",
  giftProductId: 10248282669373,
  giftVariantId: 51445390377277,
  qty: 1,
  debug: false
});

function createGwpByTag(config) {
  const {
    tag, 
    giftProductId,
    giftVariantId,
    qty = 1,
    debug = false
  } = config;

  let processing = false;
  let seq = 0;
  const tagCache = new Map();

  function log(...args) { if (debug) console.log("[GWP]", ...args); }

  function releaseLock() {
    setTimeout(() => { processing = false; }, 400);
  }

  function getHandle(item) {
    if (item?.handle) return item.handle;
    const url = item?.url;
    if (typeof url === "string") {
      const m = url.match(/\/products\/([^/?]+)/i);
      if (m?.[1]) return m[1];
    }
    return null;
  }

  async function fetchTags(item) {
    const pid = item?.product_id;
    if (pid && tagCache.has(pid)) return tagCache.get(pid);

    const handle = getHandle(item);
    if (!handle) return [];

    try {
      const res = await fetch(`/products/${handle}.js`, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      const raw = data?.tags;
      let arr = [];

      if (Array.isArray(raw)) arr = raw.map(t => String(t).trim()).filter(Boolean);
      else if (typeof raw === "string") arr = raw.split(",").map(t => t.trim()).filter(Boolean);

      if (pid) tagCache.set(pid, arr);
      return arr;
    } catch (e) {
      log("No pude leer tags para", { pid, handle, e });
      return [];
    }
  }

  async function hasActivator(cartItems, localSeq) {
    const realItems = (cartItems || []).filter(it => it?.product_id !== giftProductId);

    if (realItems.length === 0) return false;

    for (const item of realItems) {
      if (localSeq !== seq) return false; // cancel por carrera

      // 1) intenta tags desde Rebuy
      let raw = item?.product?.tags;
      let tags = [];

      if (raw) {
        if (Array.isArray(raw)) tags = raw.map(t => String(t).trim()).filter(Boolean);
        else if (typeof raw === "string") tags = raw.split(",").map(t => t.trim()).filter(Boolean);
      } else {
        // 2) fallback a Shopify
        tags = await fetchTags(item);
      }

      if (tags.includes(tag)) return true;
    }

    return false;
  }

  function updateCart(updates) {
    processing = true;
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates })
    })
      .then(r => r.json().catch(() => ({})))
      .catch(() => {})
      .finally(releaseLock);
  }

  function addGift() {
    processing = true;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: giftVariantId, quantity: qty })
    })
      .then(r => r.json().catch(() => ({})))
      .catch(() => {})
      .finally(releaseLock);
  }

  // ✅ Handler que llamas en rebuy:smartcart.ready y rebuy:cart.change
  return async function handleGwp(cartItems) {
    if (processing) return;

    seq += 1;
    const localSeq = seq;

    const eligible = await hasActivator(cartItems || [], localSeq);
    if (localSeq !== seq) return; // cancel por carrera

    const giftItems = (cartItems || []).filter(it => it?.product_id === giftProductId);
    const giftQty = giftItems.reduce((s, it) => s + (it?.quantity || 0), 0);

    // No elegible => eliminar todos los gifts
    if (!eligible) {
      if (giftItems.length) {
        const updates = {};
        giftItems.forEach(it => { updates[it.key] = 0; });
        log("Removing gift (not eligible)");
        return updateCart(updates);
      }
      return;
    }

    // Elegible => asegurar qty exacta (default 1)
    if (!giftItems.length) {
      log("Adding gift");
      return addGift();
    }

    if (giftQty !== qty || giftItems.length > 1) {
      const updates = {};
      giftItems.forEach((it, idx) => { updates[it.key] = idx === 0 ? qty : 0; });
      log("Normalizing gift qty");
      return updateCart(updates);
    }

    // ya está bien
    log("Gift OK");
  };
}




// ==========================================
// Cart Countdown Campaign
// ==========================================

const REBUY_CART_COUNTDOWN_CONFIG = {
  enabled: true, // activar / desactivar campaña manualmente
  durationMs: 10 * 60 * 1000, // 10 minutos
  storageKey: 'rebuy_cart_countdown_expires_at',
  debug: false,

  copyFilled: 'Saving your items for',
  copyEmpty: 'Your saved cart expires in',

  // Variantes rápidas por si quieres cambiarlas luego
  variants: {
    filled: [
      'Complete your order in',
      'Your cart is active for',
      "We're holding your cart for"
    ],
    empty: [
      'Your 10-minute window is still active',
      'Add your items before time runs out',
      'Your shopping window ends in'
    ]
  }
};

let rebuyCartCountdownInterval = null;
let rebuyCartLastKnownQty = null;

function rebuyCountdownLog(...args) {
  if (REBUY_CART_COUNTDOWN_CONFIG.debug) {
    console.log('[Rebuy Countdown]', ...args);
  }
}

function getRebuyCountdownExpiresAt() {
  const raw = localStorage.getItem(REBUY_CART_COUNTDOWN_CONFIG.storageKey);
  const value = raw ? parseInt(raw, 10) : NaN;
  return Number.isFinite(value) ? value : null;
}

function setRebuyCountdownExpiresAt(expiresAt) {
  localStorage.setItem(REBUY_CART_COUNTDOWN_CONFIG.storageKey, String(expiresAt));
}

function clearRebuyCountdownExpiresAt() {
  localStorage.removeItem(REBUY_CART_COUNTDOWN_CONFIG.storageKey);
}

function hasActiveRebuyCountdown() {
  const expiresAt = getRebuyCountdownExpiresAt();
  return !!expiresAt && expiresAt > Date.now();
}

function getRebuyCountdownRemainingMs() {
  const expiresAt = getRebuyCountdownExpiresAt();
  if (!expiresAt) return 0;
  return Math.max(0, expiresAt - Date.now());
}

function formatRebuyCountdown(ms) {
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

function getOrCreateRebuyCountdownNode() {
  const bodyAnchor = document.querySelector('#rebuy-cart div[data-rebuy-cart-anchor="body"]');
  const progressNode = bodyAnchor?.querySelector('.rebuy-cart-gwp-progress');

  if (!bodyAnchor) {
    rebuyCountdownLog('Body anchor not found yet');
    return null;
  }

  let countdownNode = bodyAnchor.querySelector('.rebuy-cart-countdown-wrapper');

  if (!countdownNode) {
    countdownNode = document.createElement('div');
    countdownNode.className = 'rebuy-cart-countdown-wrapper';
    countdownNode.innerHTML = `
      <div class="rebuy-cart-countdown">
        <div class="rebuy-cart-countdown__left">
          <svg class="rebuy-cart-countdown__icon" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M12 1.75A10.25 10.25 0 1 0 22.25 12 10.26 10.26 0 0 0 12 1.75Zm0 19A8.75 8.75 0 1 1 20.75 12 8.76 8.76 0 0 1 12 20.75Zm.75-13.5h-1.5v5.19l3.97 2.38.77-1.29-3.24-1.94Z"></path>
          </svg>
          <p class="rebuy-cart-countdown__text"></p>
        </div>
        <div class="rebuy-cart-countdown__time">10:00</div>
      </div>
    `;
  }

  if (progressNode) {
    if (progressNode.nextElementSibling !== countdownNode) {
      progressNode.insertAdjacentElement('afterend', countdownNode);
    }
  } else if (!countdownNode.parentNode) {
    bodyAnchor.prepend(countdownNode);
  } else if (bodyAnchor.firstElementChild !== countdownNode) {
    bodyAnchor.prepend(countdownNode);
  }

  return countdownNode;
}

function removeRebuyCountdownNode() {
  const node = document.querySelector('#rebuy-cart .rebuy-cart-countdown-wrapper');
  if (node) node.remove();
}

function stopRebuyCountdownTicker() {
  if (rebuyCartCountdownInterval) {
    clearInterval(rebuyCartCountdownInterval);
    rebuyCartCountdownInterval = null;
  }
}

function clearRebuyCartCountdown() {
  stopRebuyCountdownTicker();
  clearRebuyCountdownExpiresAt();
  removeRebuyCountdownNode();
  rebuyCountdownLog('Countdown cleared');
}

function renderRebuyCartCountdown(currentQty) {
  if (!REBUY_CART_COUNTDOWN_CONFIG.enabled) {
    clearRebuyCartCountdown();
    return;
  }

  const remainingMs = getRebuyCountdownRemainingMs();

  if (remainingMs <= 0) {
    clearRebuyCartCountdown();
    return;
  }

  const node = getOrCreateRebuyCountdownNode();
  if (!node) return;

  const textNode = node.querySelector('.rebuy-cart-countdown__text');
  const timeNode = node.querySelector('.rebuy-cart-countdown__time');

  const message = currentQty > 0
    ? REBUY_CART_COUNTDOWN_CONFIG.copyFilled
    : REBUY_CART_COUNTDOWN_CONFIG.copyEmpty;

  textNode.textContent = message;
  timeNode.textContent = formatRebuyCountdown(remainingMs);
}

function startRebuyCountdownTicker(getQty) {
  stopRebuyCountdownTicker();

  rebuyCartCountdownInterval = setInterval(function() {
    const remainingMs = getRebuyCountdownRemainingMs();

    if (remainingMs <= 0) {
      clearRebuyCartCountdown();
      return;
    }

    const qty = typeof getQty === 'function' ? getQty() : 0;
    renderRebuyCartCountdown(qty);
  }, 1000);
}

function startRebuyCartCountdown(currentQty) {
  if (!REBUY_CART_COUNTDOWN_CONFIG.enabled) return;

  const expiresAt = Date.now() + REBUY_CART_COUNTDOWN_CONFIG.durationMs;
  setRebuyCountdownExpiresAt(expiresAt);

  rebuyCountdownLog('Countdown started', {
    expiresAt,
    qty: currentQty
  });

  renderRebuyCartCountdown(currentQty);
  startRebuyCountdownTicker(function() {
    return rebuyCartLastKnownQty || 0;
  });
}

function ensureRebuyCartCountdownRunning(currentQty) {
  if (!REBUY_CART_COUNTDOWN_CONFIG.enabled) {
    clearRebuyCartCountdown();
    return;
  }

  if (!hasActiveRebuyCountdown()) {
    clearRebuyCartCountdown();
    return;
  }

  renderRebuyCartCountdown(currentQty);
  startRebuyCountdownTicker(function() {
    return rebuyCartLastKnownQty || 0;
  });
}

function handleRebuyCartCountdown(currentQty) {
  if (!REBUY_CART_COUNTDOWN_CONFIG.enabled) {
    clearRebuyCartCountdown();
    rebuyCartLastKnownQty = currentQty;
    return;
  }

  const previousQty = rebuyCartLastKnownQty;
  const hasTimer = hasActiveRebuyCountdown();

  // Primer render / apertura del cart
  if (previousQty === null) {
    rebuyCartLastKnownQty = currentQty;

    if (hasTimer) {
      ensureRebuyCartCountdownRunning(currentQty);
    } else {
      removeRebuyCountdownNode();
    }

    rebuyCountdownLog('Initial state', { previousQty, currentQty, hasTimer });
    return;
  }

  // Nuevo trigger:
  // si NO hay timer activo y la cantidad sube, asumimos un add-to-cart real
  const shouldStartNewCountdown =
    !hasTimer &&
    currentQty > previousQty;

  if (shouldStartNewCountdown) {
    rebuyCartLastKnownQty = currentQty;
    startRebuyCartCountdown(currentQty);
    return;
  }

  rebuyCartLastKnownQty = currentQty;

  if (hasTimer) {
    ensureRebuyCartCountdownRunning(currentQty);
  } else {
    removeRebuyCountdownNode();
  }

  rebuyCountdownLog('State updated', {
    previousQty,
    currentQty,
    hasTimer
  });
}







// ==========================================
// Rebuy Gift Wrapping Module
// ==========================================

function createRebuyGiftWrapping(userConfig) {
  const config = {
    debug: false,

    selectors: {
      body: '#rebuy-cart div[data-rebuy-cart-anchor="body"]',
      crossSell: '#rebuy-cart div[data-rebuy-component="cross-sell-widget"]',
      smartCartItems: '#rebuy-cart ul[data-smartcart-items]'
    },

    placement: {
      mode: 'beforeCrossSell' // beforeCrossSell | afterItems | topOfBody
    },

    product: {
      productId: null,
      variantId: null
    },

    copy: {
      checkboxTitle: 'Is This a Gift?',
      checkboxLabel: 'Add Note & Wrapping',
      successMessage: 'Added Gift Wrapping',
      notesLabel: 'Notes',
      notesPlaceholder: 'Add Notes Here (optional)',
      buttonLabel: 'Add Wrapping & Note',
      disclaimer: 'Your message will be printed on the receipt but prices are hidden.'
    },

    media: {
      image: ''
    },

    properties: {
      noteKey: 'Note'
    },

    ...userConfig
  };

  let isProcessing = false;

  function log() {
    if (!config.debug) return;
    console.log.apply(console, ['[Gift Wrapping]'].concat([].slice.call(arguments)));
  }

  function getRoot() {
    return document.querySelector('#rebuy-cart .rebuy-cart__gift-module');
  }

  function getBody() {
    return document.querySelector(config.selectors.body);
  }

  function getGiftItems(cartItems) {
    return (cartItems || []).filter(function(item) {
      return (
        String(item.product_id) === String(config.product.productId) ||
        String(item.variant_id) === String(config.product.variantId) ||
        String(item.id) === String(config.product.variantId)
      );
    });
  }

  function getNonGiftItems(cartItems) {
    return getRealProductItems(cartItems);
  }

  function clearInputs() {
    const root = getRoot();
    if (!root) return;

    const checkbox = root.querySelector('[data-gift-toggle]');
    const note = root.querySelector('[data-gift-note]');
    const panel = root.querySelector('[data-gift-panel]');

    if (checkbox) checkbox.checked = false;
    if (note) note.value = '';
    if (panel) $(panel).hide();
  }

  function showSuccessState() {
    const root = getRoot();
    if (!root) return;

    const success = root.querySelector('[data-gift-success]');
    const form = root.querySelector('[data-gift-form]');

    if (success) success.style.display = 'block';
    if (form) form.style.display = 'none';
  }

  function showFormState() {
    const root = getRoot();
    if (!root) return;

    const success = root.querySelector('[data-gift-success]');
    const form = root.querySelector('[data-gift-form]');
    const panel = root.querySelector('[data-gift-panel]');
    const checkbox = root.querySelector('[data-gift-toggle]');
    const note = root.querySelector('[data-gift-note]');

    if (success) success.style.display = 'none';
    if (form) form.style.display = 'block';
    if (panel) panel.style.display = 'none';
    if (checkbox) checkbox.checked = false;
    if (note) note.value = '';
  }

  function hideModule() {
    const root = getRoot();
    if (root) root.style.display = 'none';
  }

  function showModule() {
    const root = getRoot();
    if (root) root.style.display = '';
  }

  function buildHtml() {
    return `
      <div class="rebuy-cart__gift-module" data-gift-module>
        <div class="rebuy-cart__gift-success" data-gift-success style="display:none;">
          <span>${config.copy.successMessage}</span>
        </div>

        <div class="rebuy-cart__gift-form" data-gift-form>
          <label class="rebuy-cart__gift-toggle-row" for="rebuy-gift-toggle">
            <div class="rebuy-cart__gift-title">${config.copy.checkboxTitle}</div>

            <div class="rebuy-cart__gift-input">
              <input
                type="checkbox"
                id="rebuy-gift-toggle"
                data-gift-toggle
              >
              <span>${config.copy.checkboxLabel}</span>
            </div>
          </label>

          <div class="rebuy-cart__gift-panel" data-gift-panel style="display:none;">
            <div class="rebuy-cart__gift-disclaimer">
              <p>${config.copy.disclaimer}</p>
            </div>

            ${
              config.media.image
                ? `
                <div class="rebuy-cart__gift-image">
                  <img src="${config.media.image}" alt="Gift wrapping" loading="lazy">
                </div>
                `
                : ''
            }

            <div class="rebuy-cart__gift-note-wrap">
              <label for="rebuy-gift-note">${config.copy.notesLabel}</label>
              <textarea
                id="rebuy-gift-note"
                data-gift-note
                placeholder="${config.copy.notesPlaceholder}"
              ></textarea>
            </div>

            <button type="button" class="rebuy-cart__gift-button" data-gift-add>
              ${config.copy.buttonLabel}
            </button>
          </div>
        </div>
      </div>
    `;
  }

  function moveModuleToCorrectPosition() {
    const root = getRoot();
    if (!root) return;

    const body = getBody();
    if (!body) return;

    if (config.placement.mode === 'afterItems') {
      const items = document.querySelector(config.selectors.smartCartItems);
      if (items && items.nextElementSibling !== root) {
        items.insertAdjacentElement('afterend', root);
      }
      return;
    }

    if (config.placement.mode === 'beforeCrossSell') {
      const crossSell = document.querySelector(config.selectors.crossSell);
      if (crossSell && crossSell.previousElementSibling !== root) {
        crossSell.insertAdjacentElement('beforebegin', root);
      }
      return;
    }

    if (config.placement.mode === 'topOfBody') {
      if (body.firstElementChild !== root) {
        body.insertAdjacentElement('afterbegin', root);
      }
    }
  }

  function insertModule() {
    if (getRoot()) {
      moveModuleToCorrectPosition();
      return;
    }

    const body = getBody();
    if (!body) return;

    const html = buildHtml();

    // Primero lo insertamos en un lugar seguro
    body.insertAdjacentHTML('afterbegin', html);

    // Luego intentamos moverlo a su posición final
    moveModuleToCorrectPosition();
  }

  function ensureModule() {
    insertModule();
    bindEvents();

    // Reintentos cortos por si Rebuy todavía no terminó de pintar el carrito
    setTimeout(moveModuleToCorrectPosition, 80);
    setTimeout(moveModuleToCorrectPosition, 180);
    setTimeout(moveModuleToCorrectPosition, 350);
  }

  function bindEvents() {
    const root = getRoot();
    if (!root || root.dataset.bound === 'true') return;

    root.dataset.bound = 'true';

    const toggle = root.querySelector('[data-gift-toggle]');
    const panel = root.querySelector('[data-gift-panel]');
    const addBtn = root.querySelector('[data-gift-add]');

    if (toggle && panel) {
      toggle.addEventListener('change', function() {
        if (toggle.checked) {
          $(panel).slideDown();
        } else {
          $(panel).slideUp();
          const note = root.querySelector('[data-gift-note]');
          if (note) note.value = '';
        }
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function() {
        addGiftToCart();
      });
    }
  }

  function addGiftToCart() {
    if (isProcessing) return;

    const root = getRoot();
    if (!root) return;

    const note = root.querySelector('[data-gift-note]')?.value || '';

    isProcessing = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: config.product.variantId,
        quantity: 1,
        properties: {
          [config.properties.noteKey]: note
        }
      })
    })
      .then(function(res) {
        return res.json().catch(function() { return {}; });
      })
      .then(function() {
        clearInputs();
        showSuccessState();
      })
      .catch(function(err) {
        log('Error adding gift wrapping', err);
      })
      .finally(function() {
        setTimeout(function() {
          isProcessing = false;
        }, 400);
      });
  }

  function removeGiftFromCart(lines) {
    if (!lines || !lines.length || isProcessing) return;

    const updates = {};
    lines.forEach(function(line) {
      updates[line.key] = 0;
    });

    isProcessing = true;

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function(res) {
        return res.json().catch(function() { return {}; });
      })
      .catch(function(err) {
        log('Error removing gift wrapping', err);
      })
      .finally(function() {
        setTimeout(function() {
          isProcessing = false;
        }, 400);
      });
  }

  function sync(cartItems) {
    ensureModule();

    const giftItems = getGiftItems(cartItems);
    const nonGiftItems = getNonGiftItems(cartItems);
    const totalNonGiftQty = nonGiftItems.reduce(function(acc, item) {
      return acc + (item.quantity || 0);
    }, 0);

    const giftQty = giftItems.reduce(function(acc, item) {
      return acc + (item.quantity || 0);
    }, 0);

    log('sync', {
      totalNonGiftQty: totalNonGiftQty,
      giftQty: giftQty,
      giftItems: giftItems
    });

    // Sin productos reales: ocultar módulo y eliminar wrapping si quedó solo
    if (totalNonGiftQty <= 0) {
      hideModule();

      if (giftItems.length) {
        removeGiftFromCart(giftItems);
      }

      return;
    }

    showModule();

    // Hay wrapping agregado
    if (giftItems.length) {
      showSuccessState();

      // Normalizar duplicados
      if (giftQty > 1 || giftItems.length > 1) {
        const updates = {};
        giftItems.forEach(function(line, index) {
          updates[line.key] = index === 0 ? 1 : 0;
        });

        isProcessing = true;

        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        })
          .then(function(res) {
            return res.json().catch(function() { return {}; });
          })
          .finally(function() {
            setTimeout(function() {
              isProcessing = false;
            }, 400);
          });
      }

      return;
    }

    // No hay wrapping
    showFormState();
  }

  return {
    init: function(cartItems) {
      ensureModule();
      sync(cartItems || []);
    },
    sync: sync
  };
}

const rebuyGiftWrapping770 = createRebuyGiftWrapping({
  debug: true,

  selectors: {
    body: '#rebuy-cart div[data-rebuy-cart-anchor="body"]',
    crossSell: '#rebuy-cart div[data-rebuy-component="cross-sell-widget"]',
    smartCartItems: '#rebuy-cart ul[data-smartcart-items]'
  },

  placement: {
    mode: 'afterItems'
  },

  product: {
    productId: 10306204041533,
    variantId: 51588565238077
  },

  copy: {
    checkboxTitle: 'Is This a Gift?',
    checkboxLabel: 'Add Note & Wrapping',
    successMessage: 'Added Gift Wrapping',
    notesLabel: 'Notes',
    notesPlaceholder: 'Add Notes Here (optional)',
    buttonLabel: 'Add Wrapping & Note',
    disclaimer: 'Your message will be handwritten.'
  },

  media: {
    image: 'https://cdn.shopify.com/s/files/1/0047/7075/8756/files/imagen-notes-wrapping.png?v=1793844983'
  },

  properties: {
    noteKey: 'Note'
  }
});









/* Triggers Rebuy Events */

document.addEventListener('rebuy:smartcart.ready', function(event){
  console.log('rebuy:smartcart.ready event', event.detail);
  var $qty = event.detail.smartcart.cart.item_count;
  var $total_price = event.detail.smartcart.cart.total_price;
  var $array_products = event.detail.smartcart.cart.items;

  $('div[data-rebuy-cart-scroll-area]').on('scroll', function() {
    if ($(this).scrollTop() > 0) {
      $('div[data-rebuy-cart-anchor=header]').addClass('scroll-move-header');
    } else {
      $('div[data-rebuy-cart-anchor=header]').removeClass('scroll-move-header');
    }
  });

  $reindexacionRebuy();
  ajustarAltura();


  setTimeout(function() {
    handleRebuyCartCountdown($qty);
  }, 80);

  if($qty > 0){
    $('#rebuy-cart [data-rebuy-cart-anchor=footer]').removeClass('hidden-footer');
  } else {
    $('#rebuy-cart [data-rebuy-cart-anchor=footer]').addClass('hidden-footer');
  }

  // handleSecondPiercingGWP($array_products);

  setTimeout(function() {
    bootRebuyHulkGwp();
  }, 120);


  setTimeout(function() {
    rebuyGiftWrapping770.init($array_products);
  }, 140);

  renderGroupSet();
  setTimeout(GroupSet, 1000);

});



document.addEventListener('rebuy:cart.change', function(event){
  console.log('rebuy:cart.change event', event.detail);

  var $qty_rebuy = event.detail.cart.cart.item_count;
  var $array_products = event.detail.cart.cart.items;
  var $total_price = event.detail.cart.cart.total_price;

  if($qty_rebuy > 0){
    $('#rebuy-cart [data-rebuy-cart-anchor=footer]').removeClass('hidden-footer');
  } else {
    $('#rebuy-cart [data-rebuy-cart-anchor=footer]').addClass('hidden-footer');
  }

  $('.thb-secondary-area .thb-item-count').text($qty_rebuy);

  // handleSecondPiercingGWP($array_products);

  setTimeout(function() {
    handleRebuyCartCountdown($qty_rebuy);
  }, 80);

  setTimeout(function() {
    bootRebuyHulkGwp();
  }, 120);

  setTimeout(function() {
    rebuyGiftWrapping770.sync($array_products);
  }, 140);

  setTimeout(function() {
    rebuyGiftWrapping770.sync($array_products);
  }, 320);

  var $containerSets = $('#rebuy-cart div[data-rebuy-cart-anchor="body"] .rebuy-cart__flyout-sets');
  if ($containerSets.length > 0) {
    setTimeout(GroupSet, 1000);
  };
  
});




document.addEventListener('rebuy.ready', function(event){
  runUpsellCart();
  console.log('rebuy.ready event', event.detail);
});

document.addEventListener('rebuy.productsChange', function(event){
  requestAnimationFrame(runUpsellCart);
  console.log('rebuy.productsChange event', event.detail);
});

function runUpsellCart(){
  $('#rebuy-cart .rebuy-widget-content .rebuy-product-grid > div')
  .each(function(){
    var $item = $(this);
    var urlProduct = $item.find('.rebuy-product-info a.rebuy-product-title-link').attr('href');
    var $actions = $item.find('.rebuy-product-actions');
    if(!urlProduct || !$actions.length) return;
    var $existingBtn = $actions.find('.personalize-btn');
    if ($existingBtn.length){
      $existingBtn.attr('href', urlProduct);
      return;
    }
    $actions.append(
      '<a class="rebuy-button personalize-btn" href="' + urlProduct + '">Personalize</a>'
    );
  });
}








/* Script para SETS */


function renderGroupSet() {
  var $body = $('#rebuy-cart div[data-rebuy-cart-anchor="body"]');

  if (!$body.length) return;
  if ($body.find('.rebuy-cart__flyout-sets').length) return;

  var setsHtml =
    '<div class="rebuy-cart__flyout-sets"><h4 id="heading-product-sets">Product Sets:</h4></div>' +
    '<div class="title-simple-products">Individual Products:</div>';

  var $countdown = $body.find('.rebuy-cart-countdown-wrapper');
  var $progress = $body.find('.rebuy-cart-gwp-progress');

  if ($countdown.length) {
    $countdown.after(setsHtml);
  } else if ($progress.length) {
    $progress.after(setsHtml);
  } else {
    $body.prepend(setsHtml);
  }
}



function GroupSet(){

  var grupos = {};
  var cantidadElementos = 0;
  var lineItemsBasic = 0;
    
  $("div#rebuy-cart ul[data-smartcart-items] li.rebuy-cart__flyout-item").each(function() {
  
      var classes = $(this).attr("class").split(" ");
      var idClass = classes.find(function(className) {
          return className.startsWith("property-id-set:"); 
      });
  
      if (idClass) {
          var id = idClass.split(":")[1];
        
          if (!grupos[id]) {
              grupos[id] = [];
          };
          
          grupos[id].push(this);
      } else {
        
        lineItemsBasic++;
        
      };
      
  });

  for (var id in grupos) {
    if($('div#rebuy-cart .rebuy-cart__flyout-sets ul.' + id).length === 0){

      
      var lista = $("<ul class='" + id + "'></ul>");
      
      var containerSet = $(`
        <div class="container-set-rebuy container-set-rebuy--${id}">
          <div class="rebuy-cart__flyout-item">
            <div class="rebuy-cart__flyout-item-media">
              <a href tabindex="-1">
                <img src>
              </a>
            </div>
            <div class="rebuy-cart__flyout-item-info">
              <a role="heading" aria-level="5" href class="rebuy-cart__flyout-item-product-title"></a>
              <div class="rebuy-cart__flyout-item-discount-message rebuy-cart__flyout-item-discount-message--hide"></div>
              <div class="rebuy-cart__flyout-item-properties">
                <div class="rebuy-cart__flyout-item-property property-key-id-set">
                  <span class="rebuy-cart__flyout-item-property-name">ID SET</span>
                  <span class="rebuy-cart__flyout-item-property-separator">:</span>
                  <span class="rebuy-cart__flyout-item-property-value">${id}</span>
                </div>
              </div>
              <button type="button" class="rebuy-cart__flyout-item-remove">
                <i aria-hidden="true" class="far fa-trash"></i>
              </button>
              <div class="rebuy-cart__flyout-item-price">
                <div>
                  <span class="rebuy-money-sale"><span></span></span>
                  <span class="rebuy-money-regular"><span class="sr-only">Price</span> <span></span></span>
                </div>
              </div>
              <div class="rebuy-cart__flyout-item-quantity">
                <div class="container-button-view-all-products">
                  <span class="view-products button-active">View Products</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      `);

      
      var elementosOriginales = grupos[id];


      if (elementosOriginales.length >= 1) {
        elementosOriginales.forEach(function(elementoOriginal) {
            var copiaElemento = $(elementoOriginal).clone();
            lista.append(copiaElemento);
        }); 
      };
      

      $('.rebuy-cart__flyout-sets').prepend(containerSet);
      $('.rebuy-cart__flyout-sets .container-set-rebuy--' + id +'').append(lista);
      
    };

    cantidadElementos++;

  };


  $('.rebuy-cart__flyout-sets').prepend($('#heading-product-sets'));


  $('.rebuy-cart__flyout-sets .container-set-rebuy').each(function(){
      var selector = $(this).find('> div.rebuy-cart__flyout-item');
      var items = $(this).find('ul li');
      var totalSet = 0;
      var totalSetOffer = 0;
      var totalSetRegular = 0;
      items.each(function(){

        
        // THE CURATED LOCKET
        if($(this).hasClass('product-the-curated-locket')){
          var titleChange = 'The Curated Locket';
          var urlChange = '/products/the-curated-locket';
          var imagenChange = 'https://www.770finejewelry.com/cdn/shop/files/Generated_with_Kive.ai_-_kive-image-17_240x240.png'; 
          $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
          $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
          $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
          $(selector).find('.rebuy-cart__flyout-item-info > a.rebuy-cart__flyout-item-product-title').text(titleChange);
        };


        // THE SUMMER CURATED LOCKET
        if($(this).hasClass('product-the-summer-curated-locket-includes-1-diamond-locket-3-free-charms')){
          var titleChange = 'The Summer Curated Locket';
          var urlChange = '/products/the-summer-curated-locket-includes-1-diamond-locket-3-free-charms';
          var imagenChange = 'https://770finejewelry.com/cdn/shop/files/Generated_with_Kive.ai_-_kive-image-357_240x240.png'; 
          $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
          $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
          $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
          $(selector).find('.rebuy-cart__flyout-item-info > a.rebuy-cart__flyout-item-product-title').text(titleChange);
        };


        // LIMITED EDITION CURATED HEART
        if($(this).hasClass('product-limited-edition-the-curated-locket-includes-1-diamond-locket-3-free-charms-copy')){
          var titleChange = 'Limited Edition Curated Heart Locket';
          var urlChange = '/products/limited-edition-the-curated-locket-includes-1-diamond-locket-3-free-charms-copy';
          var imagenChange = 'https://www.770finejewelry.com/cdn/shop/files/770heartlocket_curated_240x240.jpg'; 
          $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
          $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
          $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
          $(selector).find('.rebuy-cart__flyout-item-info > a.rebuy-cart__flyout-item-product-title').text(titleChange);
        };
        


        /* Precio Normal sin Descuento */
        let priceValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').text();
        let price = Math.round(parseFloat(priceValue.replace(/[$,]/g, '')) * 100);
        totalSet += price;

        /* Precio Oferta con Cupón */
        let priceSaleValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money.sale span:not(.sr-only)').text();
        let priceSale = Math.round(parseFloat(priceSaleValue.replace(/[$,]/g, '')) * 100);
        totalSetOffer += priceSale;

        /* Precio Regular con Cupón */
        let priceRegularValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money.compare-at span:not(.sr-only)').text();
        let priceRegular = Math.round(parseFloat(priceRegularValue.replace(/[$,]/g, '')) * 100);
        totalSetRegular += priceRegular;

      });

      if(totalSetOffer > 0){
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular').addClass('rebuy-money-regular__crossline');
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-sale span:not(.sr-only)').text((totalSetOffer / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular span:not(.sr-only)').text((totalSetRegular / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
      } else {
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular span:not(.sr-only)').text((totalSet / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
      }

  });



  
  
  if(cantidadElementos > 0){
    $('#rebuy-cart div[data-rebuy-cart-anchor="body"] .rebuy-cart__flyout-sets').css('display','flex');
  } else {
    $('#rebuy-cart div[data-rebuy-cart-anchor="body"] .rebuy-cart__flyout-sets').hide();
  };

  if(lineItemsBasic > 0){
    $('#rebuy-cart div[data-rebuy-cart-anchor="body"] ul[data-smartcart-items]').show();
  } else {
    $('#rebuy-cart div[data-rebuy-cart-anchor="body"] ul[data-smartcart-items]').hide();
  };


  if(cantidadElementos > 0 && lineItemsBasic > 0){
    $('#rebuy-cart div[data-rebuy-cart-anchor="body"] .rebuy-cart__flyout-sets h4').show();
    $('#rebuy-cart div[data-rebuy-cart-anchor="body"] .title-simple-products').show();
  } else {
    $('#rebuy-cart div[data-rebuy-cart-anchor="body"] .rebuy-cart__flyout-sets h4').hide();
    $('#rebuy-cart div[data-rebuy-cart-anchor="body"] .title-simple-products').hide();
  };


};




$(document).on('click', '.container-set-rebuy button.rebuy-cart__flyout-item-remove', function () {
    var $selectorItem = ($(this).parents('.container-set-rebuy').find('> ul').attr('class')).toUpperCase();
    var $selectorProducts = $(this).parents('.container-set-rebuy').find('> ul').attr('class');
    console.log('Selector Products:', $selectorItem);

    var $removeSet = $('.rebuy-cart__flyout-sets .container-set-rebuy--' + $selectorProducts);
    $($removeSet).replaceWith('<div class="container-set-rebuy--' + $selectorProducts +' rebuy-cart__flyout-sets--deleted"><div class="load-more__spinner"></div><p>Remove set</p></div>');

    $.getJSON('/cart.js', function(cart) {
        console.log('Carrito obtenido:', cart);
        var updatesObj = {};

        var itemsToDelete = cart.items.filter(item => item.properties && item.properties['ID SET'] === $selectorItem);
        console.log('Items to Delete:', itemsToDelete);

        itemsToDelete.forEach(function(item) {
            updatesObj[item.key] = 0;
        });

        console.log('Updates Object:', updatesObj);

        if (Object.keys(updatesObj).length > 0) {
            $.post('/cart/update.js', {
                updates: updatesObj
            }, function(response) {
                console.log('Carrito actualizado:', response);
                $('.container-set-rebuy--' + $selectorProducts).remove();
            }).fail(function(error) {
                console.error('Error al actualizar el carrito', error);
            });
        }
    }).fail(function(error) {
        console.error('Error al obtener el carrito:', error);
    });
});



$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-active', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideDown();
  $(this).text('Hide Products');
  $(this).removeClass('button-active');
  $(this).addClass('button-off');
});

$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-off', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideUp();
  $(this).text('View Products');
  $(this).removeClass('button-off');
  $(this).addClass('button-active');
});